import TableOfColors from "../../../../coloreshtml/mdx/colore-html/TableOfColors.js";
import * as React from 'react';
export default {
  TableOfColors,
  React
};